import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import PortfolioPage from './pages/PortfolioPage';
import PortfolioListPage from './pages/PortfolioListPage';
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DynamicPage from './pages/DynamicPage';
import CollectionPage from './pages/CollectionPage';
import FloatingContact from './components/FloatingContact';
import BackToTop from './components/BackToTop';
import LoadingScreen from './components/LoadingScreen';
import CookieConsent from './components/CookieConsent';
import MemorialSplash from './components/MemorialSplash';
import ThemeProvider from './components/ThemeProvider';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
    <ThemeProvider>
      <Router>
        <MemorialSplash />
        <LoadingScreen />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<PortfolioListPage />} />
          <Route path="/portfolio/:id" element={<PortfolioPage />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/page/:slug" element={<DynamicPage />} />
          <Route path="/collection/:slug" element={<CollectionPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FloatingContact />
        <BackToTop />
        <CookieConsent />
      </Router>
    </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
